import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';
import API from '../api';


class PatientRegistration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            userRegistered: false,
            patient: {},
            trigger: false,
        };

        this.triggetNext = this.triggetNext.bind(this);
    }

    componentWillMount() {
        const {steps,updateStore} = this.props;
        const year = steps.dob_year.value;
        const month = steps.dob_month.value;
        const day = steps.dob_day.value;
        let DOB = year + '-' + month + '-' + day;
        const bodyFormData = new FormData();
        bodyFormData.append('first_name', steps.first_name.value);
        bodyFormData.append('first_name_english', steps.first_name.value);
        bodyFormData.append('last_name', steps.last_name.value);
        bodyFormData.append('last_name_english', steps.last_name.value);
            // bodyFormData.append('gender',steps.userGender.value);
        bodyFormData.append('dob', DOB);
        bodyFormData.append('registration_number', steps.userID.value);
        bodyFormData.append('mobile_phone', steps.userPhone.value);

        API.post(
            '/createPatient',
            bodyFormData,
            {headers: {'Content-Type': 'multipart/form-data'}})
            .then((res) => {
                const result = res.data;
                if (result.status == "success") {
                    if (result.data.length > 0) {
                        let patientData = result.data[0];
                        updateStore('patient', {
                            id: patientData.patient_id,
                            name: patientData.first_name,
                            email: patientData.email,
                            verified: true
                        });

                        this.setState(
                            {loading: false, userRegistered: true, patient: result.data[0]}
                        );
                        this.triggetNext(result.data[0], 'getServices_ask');
                    } else {
                        this.setState(
                            {loading: false, patient: false}
                        );
                        this.triggetNext(true, 'say_hello');
                    }
                }
            }).catch((error) => {
            this.setState({
                error: 'Error retrieving data',
                loading: false
            });
            this.triggetNext(false, 'say_hello');

        });
    }

    triggetNext(value, trigger) {
        this.setState({trigger: true});
        this.props.triggerNextStep({value: value, trigger: trigger})
    }

    render() {
        const {loading, userRegistered} = this.state;
        const {step} = this.props;

        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (
                    userRegistered ? (
                        <span>{step.metadata.successMsg}</span>
                    ) : (
                        <span>{step.metadata.errorMsg}</span>
                    )
                )}
            </div>
        );
    }

}

PatientRegistration.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

PatientRegistration.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default PatientRegistration;
